import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { forgotPassword } from '@epicuro-next/state/user-state';
import { Store } from '@ngrx/store';

@Component({
  selector: 'epc-auth-forgot-password',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  standalone: false,
})
export class ForgotPasswordComponent {
  private fb = inject(NonNullableFormBuilder);
  private store = inject(Store);
  private route = inject(ActivatedRoute);

  public forgotPasswordForm = this.fb.group({
    username: [
      this.route.snapshot.queryParamMap.get('userId') ?? '',
      { validators: [Validators.required] },
    ],
  });

  public sendRequest() {
    if (this.forgotPasswordForm.invalid) {
      return;
    }

    const formValue = this.forgotPasswordForm.value;

    this.store.dispatch(
      forgotPassword({
        username: formValue.username as string,
      }),
    );
  }
}
